<template>
    <div class="aba-adiantamento">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                    />
                </div>
                <div 
                    class="column is-4" 
                    v-if="
                        permissao.create && 
                        !integracao && acertoDespesa.situacao == 3 
                        && !cantEdit
                    "
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularAdiantamento"
                    >
                        {{ $t("vincular") }} {{ $t("adiantamento") }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assAcertoAdiantamentoList"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t((f.label ? f.label : f.key)) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'valor'">
                            {{ props.row.valor | decimal(null, true) }}
                        </div>

                        <div v-else-if="f.key == 'datahorainc'">
                            <span v-if="props.row.datahorainc">
                                {{ props.row.datahorainc | moment("L LT") }}
                            </span>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <span 
                                v-if="permissao.update 
                                    && !integracao 
                                    && acertoDespesa.situacao == 3
                                    && !cantEdit
                                "
                            >
                                <b-button
                                    class="action-button"
                                    type="is-danger"
                                    icon-right="delete"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy 
                                    :title="$t('excluir')"
                                />
                            </span>
                            <b-tag 
                                class="table-tag table-tag-full-width"
                                type="is-primary"
                                size="is-medium"
                                v-if="
                                    acertoDespesa.situacao == 3
                                    && cantEdit
                                "
                            >
                                {{ $t('em-criacao') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <AdiantamentoModal
                        :acertoDespesa="acertoDespesa"
                        :selected="assAdiantamentoSelected"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssAdiantamentoAcerto from "@/services/despesas/AssAdiantamentoAcertoService.js";
import AdiantamentoModal from "@/components/despesas/acerto-despesa/modal/AdiantamentoModal.vue";

// COMPONENTS
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
        AdiantamentoModal,
    },
    props: {
        acertoDespesa: null,
        cantEdit: {
            type: Boolean,
            default: true,
        },
        isSupervisor: {
            type: Boolean,
            default: true,
        },
        parametrizacao: null,
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("DES_ACERTO_DESPESA"),
            assAdiantamentoAcertoService: [],
            fields: [
                {key: 'valor', width: 150, sortable: true},
                {key: 'observacao-geral', width: null, sortable: true},
                {key: 'datahorainc', width: 120, sortable: true},
                // {key: 'situacao', width: 100, sortable: false},
                {key: "excluir", width: 45, sortable: false},
            ],
            
            service: new AssAdiantamentoAcerto(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            assAcertoAdiantamentoList: [],
            isLoading: false,
            assAdiantamentoSelected: null,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: "",
            column: "data",
            order: "desc",
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            valorTotalAdiantamentos: 0,
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            "despesas",
            "prestacao-contas",
            "des-acerto-despesa"
        );
        
        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    watch: {
        valorTotalAdiantamentos(val) {
            this.$emit('valorTotalAdiantamentos', val);
        },
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .findAllByAcertoDespesa(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.acertoDespesa.uuid,
                    this.queryFilter,
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assAcertoAdiantamentoList = value;
                    this.isEmpty = this.assAcertoAdiantamentoList.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os usuários!");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                    this.somarValorTotalAdiantamentos();
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idadiantamento: m.idadiantamento,
                    valor: m.despesaAdiantamento.valor,
                    uuid: m.uuid,
                    situacao: m.situacao,
                    'observacao-geral': m.despesaAdiantamento.obsgeral,
                    datahorainc: m.despesaAdiantamento.datahorainc,
                    deletar: "excluir"
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        selectedPacoteEdit(selected) {
            this.assAdiantamentoSelected = selected;
            this.showModalAssociacao = true;
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t("msg-confirmacao-exclusao-n", { n: this.$t("adiantamento") });
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.$t("msg-erro-ao-desativar-n", { n: this.$t("adiantamento") });

            this.isLoading = true;
            this.service
                .updateSituacao(this.delete.uuid)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                        this.$t("msg-sucesso-ao-desativar-n", { n: this.$t("adiantamento") });

                        this.$root.showMessage("success", tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage("error", "Erro ao atualizar status.");
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("error", tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularAdiantamento() {
            this.assAdiantamentoSelected = null
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.assAdiantamentoSelected = null
            this.showModalAssociacao = false;
            this.carregarDados();
        },
        somarValorTotalAdiantamentos() {
            this.valorTotalAdiantamentos = 0;

            this.assAcertoAdiantamentoList.forEach((adiantamento) => {
                this.valorTotalAdiantamentos += adiantamento.valor;
            });

        },
    },
};
</script>

<style lang="scss" scoped>
.aba-adiantamento {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>

